import { useCallback } from 'react';
import { selectPlans, useAppInitStore } from '../../stores';

export const usePlans = () => {
	const plans = useAppInitStore(selectPlans);

	const getPlanById = useCallback((planId: number) => plans.find((p) => p.id === planId), [plans]);

	return { plans, getPlanById };
};
